import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Checkbox,
  FormControlLabel,
  IconButton,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DataList from './DataList';
import api from '../../services/api';

const UsersList = () => {
  const [open, setOpen] = useState(false);
  const [editingItem, setEditingItem] = useState(null);
  const [formData, setFormData] = useState({});
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const columns = [
    { key: 'id', label: 'ID' },
    { key: 'username', label: 'Имя пользователя' },
    { key: 'first_name', label: 'Имя' },
    { key: 'last_name', label: 'Фамилия' },
    { key: 'telegram_username', label: 'Telegram username' },
    { key: 'telegram_id', label: 'Telegram ID' },
    { key: 'email', label: 'Email' },
    { key: 'is_active', label: 'Активен', render: (value) => (value === true || value === 1 || value === "true") ? 'Да' : 'Нет' },
  ];

  const handleEdit = (item) => {
    setEditingItem(item);
    setFormData({
      ...item,
      is_active: item.is_active === true || item.is_active === 1 || item.is_active === "true"
    });
    setOpen(true);
  };

  const handleSave = async () => {
    try {
      await api.put(`/api/users/${editingItem.id}/`, formData);
      setOpen(false);
      setRefreshTrigger(prev => prev + 1);
    } catch (err) {
      console.error('Ошибка сохранения:', err);
    }
  };

  const handleClose = () => {
    setOpen(false);
    setEditingItem(null);
    setFormData({});
  };

  const renderActions = (item) => (
    <IconButton onClick={() => handleEdit(item)} size="small">
      <EditIcon />
    </IconButton>
  );

  return (
    <>
      <DataList endpoint="/api/users/" columns={columns} renderActions={renderActions} refreshTrigger={refreshTrigger} />
      <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
        <DialogTitle>Редактировать пользователя</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Имя пользователя"
            fullWidth
            variant="standard"
            value={formData.username || ''}
            onChange={(e) => setFormData({ ...formData, username: e.target.value })}
          />
          <TextField
            margin="dense"
            label="Имя"
            fullWidth
            variant="standard"
            value={formData.first_name || ''}
            onChange={(e) => setFormData({ ...formData, first_name: e.target.value })}
          />
          <TextField
            margin="dense"
            label="Фамилия"
            fullWidth
            variant="standard"
            value={formData.last_name || ''}
            onChange={(e) => setFormData({ ...formData, last_name: e.target.value })}
          />
          <TextField
            margin="dense"
            label="Telegram username"
            fullWidth
            variant="standard"
            value={formData.telegram_username || ''}
            onChange={(e) => setFormData({ ...formData, telegram_username: e.target.value })}
          />
          <TextField
            margin="dense"
            label="Telegram ID"
            fullWidth
            variant="standard"
            value={formData.telegram_id || ''}
            onChange={(e) => setFormData({ ...formData, telegram_id: e.target.value })}
          />
          <TextField
            margin="dense"
            label="Email"
            fullWidth
            variant="standard"
            value={formData.email || ''}
            onChange={(e) => setFormData({ ...formData, email: e.target.value })}
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={formData.is_active || false}
                onChange={(e) => setFormData({ ...formData, is_active: e.target.checked })}
              />
            }
            label="Активен"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Отмена</Button>
          <Button onClick={handleSave}>Сохранить</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default UsersList;